<template>
  <notifications>
    <template #body="props">
      <div class="vue-notification" :class="[props.class]">
        <button class="btn-close-notification" @click="props.close">
          <i class="fa fa-fw fa-close"></i>
        </button>
        <p class="title">
          {{ props.item.title }}
        </p>
        <div v-html="props.item.text"></div>
      </div>
    </template>
  </notifications>
  <div class="flex h-screen">
    <AsidebarMenuDesktopApp v-if="showMenuSuperior" />
    <AsidebarMenuMobileApp
        v-if="showMenuSuperior"
        :nome-usuario="getCurrentUser.name"
        :perfilUsuario="getCurrentUser.access_level"
    />

    <div class="flex-1 flex flex-col min-h-screen overflow-y-hidden">
      <navbarApp
          title="CGE"
          :nome-usuario="getCurrentUser.name"
          :perfilUsuario="getCurrentUser.access_level"
      />
      <main id="mainApp" class="flex-1 overflow-auto p-4">
        <div class="container mx-auto">
          <div>
            <router-view />
          </div>
        </div>
      </main>
      <footerMain />
    </div>
  </div>
</template>

<script>
import AsidebarMenuDesktopApp from "@/components/app/layout/asidebarMenuDesktopApp.vue";
import AsidebarMenuMobileApp from "@/components/app/layout/asidebarMenuMobileApp.vue";
import NavbarApp from "@/components/app/layout/navbarApp.vue";
import FooterMain from "@/components/app/layout/footerMain.vue";
// eslint-disable-next-line no-unused-vars
//import store from "@/store";

export default {
  name: 'App',

  computed: {
    getCurrentUser() {
      if (this.$store.getters["auth/currentUser"] && this.$store.getters["auth/isAuthenticated"]) {
        return {
          name: `${(this.$store.getters["auth/currentUser"]).name}`,
          access_level: `${(this.$store.getters["auth/currentUser"]).tipoUsuario}`
        };
      }
      return { name: "", access_level: "" };
    },
    showMenuSuperior() {
      if (this.$store.getters["auth/currentUser"]
        && this.$store.getters["auth/isAuthenticated"]
        && (this.$store.getters["auth/currentUser"]).name) {
        return true;
      }
      return false;
    },
  },

  components: {
    AsidebarMenuMobileApp,
    AsidebarMenuDesktopApp,
    NavbarApp,
    FooterMain,
  }
}
</script>

<style>
.open-launcher {
  max-height: 170% !important;
  max-width: 170% !important;
  width: 210% !important;
}

.conversation-container .avatar {
  width: 60px !important;
  height: 60px !important;
}
</style>
